document.addEventListener('DOMContentLoaded', function() {
    iniciarApp();
})

function iniciarApp() {
    navegacionFija();
    crearGaleria();
    scrollNav();

    function navegacionFija() {
        const barra = document.querySelector('.header');
        const sobreFestival = document.querySelector('.sobre-festival');
        const body = document.querySelector('body');

        window.addEventListener('scroll', function(){
            if(sobreFestival.getBoundingClientRect().bottom < 0){
                barra.classList.add('fijo');
                body.classList.add('body-scroll');
            }else{
                barra.classList.add('remover');
                body.classList.add('body-scroll');
            }
        });
    }

    function scrollNav(){
        const enlaces = document.querySelectorAll('.navegacion-principal a');
        enlaces.forEach(enlace => {
                enlace.addEventListener('click', function(e){
                    e.preventDefault();
                    
                    const seccionScroll = e.target.attributes.href.value;
                    const seccion = document.querySelector(seccionScroll);
                    seccion.scrollIntoView({behavior: "smooth"});
                });
            });
    }

    function crearGaleria() {
        const galeria = document.querySelector('.galeria-imagenes')
        
        /*for (let i = 1; i <= 12; i++) {
            const imagen = document.createElement('picture');
            imagen.innerHTML = `
                <source srcset="build/img/thumb/${i}.avif" type="image/avif">
                <source srcset="build/img/thumb/${i}.webp" type="image/webp">
                <img loading="lazy" width="200" height="300" src="build/img/thumb/${i}.jpg" alt="Imagen Galeria">
            `;
            
            galeria.appendChild(imagen);
        }*/
        
        for (let i = 1; i <= 12; i++) {
            const imagen = document.createElement('picture');

            const sourceAvif = document.createElement('source');
            sourceAvif.setAttribute('srcset', `build/img/thumb/${i}.avif`);
            sourceAvif.setAttribute('type', 'image/avif');

            const sourceWebp = document.createElement('source');
            sourceWebp.setAttribute('srcset', `build/img/thumb/${i}.webp`);
            sourceWebp.setAttribute('type', 'image/webp');

            const img = document.createElement('img');
            img.setAttribute('loading', 'lazy');
            img.setAttribute('width', '200');
            img.setAttribute('height', '300');
            img.setAttribute('src', `build/img/thumb/${i}.jpg`);
            img.setAttribute('alt', 'Imagen Galeria');

            imagen.appendChild(sourceAvif);
            imagen.appendChild(sourceWebp);
            imagen.appendChild(img);

            imagen.onclick = function(){
                mostrarImagen(i);
            }

            galeria.appendChild(imagen);
        }
    }

    function mostrarImagen(id){

        const imagen = document.createElement('picture');

        const sourceAvif = document.createElement('source');
        sourceAvif.setAttribute('srcset', `build/img/grande/${id}.avif`);
        sourceAvif.setAttribute('type', 'image/avif');

        const sourceWebp = document.createElement('source');
        sourceWebp.setAttribute('srcset', `build/img/grande/${id}.webp`);
        sourceWebp.setAttribute('type', 'image/webp');

        const img = document.createElement('img');
        img.setAttribute('loading', 'lazy');
        img.setAttribute('width', '200');
        img.setAttribute('height', '300');
        img.setAttribute('src', `build/img/grande/${id}.jpg`);
        img.setAttribute('alt', 'Imagen Galeria');

        imagen.appendChild(sourceAvif);
        imagen.appendChild(sourceWebp);
        imagen.appendChild(img);

        //Crea el overlay
        const overlay = document.createElement('div');
        overlay.appendChild(imagen);
        overlay.classList.add('overlay');
        overlay.onclick = function () {
            const body = document.querySelector('body');
            body.classList.remove('fijar-body');
            overlay.remove();
        }

        //Botón para cerrar el modal
        const cerrarModal = document.createElement('p');
        cerrarModal.textContent = 'X'
        cerrarModal.classList.add('btn-cerrar');
        cerrarModal.onclick = function () {
            const body = document.querySelector('body');
            body.classList.remove('fijar-body');
            overlay.remove();
        }
        overlay.appendChild(cerrarModal);

        //añade el overlay al hatmo
        const body = document.querySelector('body');
        body.appendChild(overlay);
        body.classList.add('fijar-body');
    }
}